import styles from "./ButtonGroup.module.scss";
import cn from "classnames";
import React from 'react';

export const ButtonGroup = ({ children, align }: {
  children?: React.ReactNode;
  align?: 'start' | 'end' | 'center' | 'stretch';
}) => {
  return (
    <div className={cn(styles.buttonGroup, styles[`align-${align}`])}>
      {children}
    </div>
  );
};
7
